import React from "react";

export interface QuestionWithAnswer {
  question: string;
  answer: string;
  slug: string;
}


interface Props extends QuestionWithAnswer {
    isAnswerVisible: boolean;
    questionClickHandler: () => void;
}

export const Question: React.FC<Props> = ({
    question,
    answer,
    isAnswerVisible,
    questionClickHandler,
    slug,
}) => {
    return (
        <div className={isAnswerVisible ? "faqItem expanded" : "faqItem"}>
            <a onClick={questionClickHandler}>
              <h4 className="mt-0 mb-0 balance" data-name={slug}>
                {question}
              </h4>
              <svg className="icon"><use href="#angle-down"/></svg>
            </a>
            <div className="answerWrapper">
                <div className="answerBox">
                    <div className="faqAnswer" dangerouslySetInnerHTML={ { __html: answer } } />
                </div>
            </div>
        </div>
    );
};
